import { render, staticRenderFns } from "./IboxContent.vue?vue&type=template&id=0f578a03&scoped=true&"
import script from "./IboxContent.vue?vue&type=script&lang=js&"
export * from "./IboxContent.vue?vue&type=script&lang=js&"
import style0 from "./IboxContent.vue?vue&type=style&index=0&id=0f578a03&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f578a03",
  null
  
)

export default component.exports